import { useMutation } from '@tanstack/react-query'
import { addWorkersToRoster } from 'api/worker'
import { useAuthContext } from 'components/auth'

interface UseAddWorkersToRosterMutation {
  rosterId: number
  onSuccess?: () => void
  onError?: (err: Error) => void
}

export function useAddWorkersToRosterMutation(
  options: UseAddWorkersToRosterMutation
) {
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async (workerIds: number[]) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }

      return addWorkersToRoster(company.id, options.rosterId, workerIds)
    },
    ...options,
  })
}
